var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-7 b-center bg-size"}),_c('div',{staticClass:"col-xl-5 p-0"})])])
}]

export { render, staticRenderFns }